// glide-ui: 5
//
// Label — Radix-backed label; flex-by-default so icons/children sit inline without wrapping.
// props: all Radix LabelPrimitive.Root props (htmlFor, className, children)
// <Label htmlFor="email">Email</Label>   <Label htmlFor="key"><Lock className="size-4" /> API key</Label>

import React, { forwardRef } from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "@glide/cn";

const labelClasses =
  "flex items-center gap-2 text-sm font-medium leading-none select-none " +
  "peer-disabled:cursor-not-allowed peer-disabled:opacity-50 " +
  "group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50";

export const Label = forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    data-slot="label"
    className={cn(labelClasses, className)}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;
